import { useState } from 'react'

import { addLocalStorage } from '../../../../infra/storage'

import { Button } from '../../../components'
import { useModalBox } from '../../../contexts'

import ExplicationDragBlockGif from '../../../assets/images/block-instructions.gif'
import ExplicationTagsGif from '../../../assets/images/tags-instructions.gif'

const ExplicationModal = () => {
  const [steps, setSteps] = useState(1)
  const { modalClose } = useModalBox()

  const handleCheckInstructionsToOk = () => {
    addLocalStorage('wexer-instructions-to-models', 'ok')
    modalClose()
  }

  return (
    <div className="instructions-modal">
      {steps === 1 && (
        <>
          <p>
            Nesta tela, você pode arrastar e soltar para reorganizar a ordem em
            que os blocos serão escritos no documento.
          </p>
          <img
            src={ExplicationDragBlockGif}
            alt="instruções para arrastar o bloco"
          />
          <Button
            onClick={() => setSteps(steps + 1)}
            className="buttons-container "
          >
            Certo!
          </Button>
        </>
      )}

      {steps === 2 && (
        <>
          <p>
            No canto direito é possível consultar todas as tags que podem ser
            utilizadas nos modelos de documentos.
          </p>
          <img src={ExplicationTagsGif} alt="instruções para legendas e tags" />
          <Button
            onClick={handleCheckInstructionsToOk}
            className="buttons-container "
          >
            Certo!
          </Button>
        </>
      )}
    </div>
  )
}

export default ExplicationModal
